module.exports = __webpack_public_path__ + "img/06.99874c8a.jpg";